import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"
// import { usePOIStore } from "./activePOIStore"

const PoiBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const PoiActive = useStore(state => state.PoiActive)
  const setPoiActive = useStore(state => state.setPoiActive)
  const poiID = useStore(state => state.poiID)
  const setPoiID = useStore(state => state.setPoiID)

  const poiState = { active: PoiActive, id: poiID }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-poizustand", 1000)
    if (role === "recipient") {
      socket.current.on("poizustand", poiZustand => {
        setPoiActive(poiZustand.active)
        setPoiID(poiZustand.id)
      })
    }
    return () => socket.current.close()
  }, [poiState, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("poizustand", poiState)
    }
  }, [poiState, role, url])

  return null
}

PoiBroadcaster.propTypes = {}

export default PoiBroadcaster
